module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Southampton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Southampton.png
// module id = 2089
// module chunks = 4